module.exports = __webpack_public_path__ + "img/sweden-transport-accidents-female.1bf8f357.png";